// @ts-ignore
const CustomIconTrueffortScreen = ({icon}) => {
    return (
        <div className="class-icon">{icon}</div>
    )
};

export default CustomIconTrueffortScreen;